import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import AdminMenu from "../../AdminMenu";
import { getFranchiseStoreMappedList } from "../../../services/FranchiseModal/Franchise";
import { formatDate } from "../../../constants/FormateDate";
import FinanceAdminMenu from "../../FinanceAdminMenu";

const FranchiseStoreListAdmin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {};

  const [franchiseListInfoData, setFranchiseListInfoData] = useState([]);
  const [franchiseStoreListInfoData, setFranchiseStoreListInfoData] = useState(
    [],
  );

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  const [loading, setLoading] = useState(false);

  const fetchFranchise = () => {
    setLoading(true);
    getFranchiseStoreMappedList(brandId, item.id)
      .then((response) => {
        if (!response.data.error) {
          const ResList = response.data.list.filter(
            (item) => item.status === true,
          );
          const ResStoreList = response.data.storeList;
          setFranchiseListInfoData(ResList);
          setFranchiseStoreListInfoData(ResStoreList);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchFranchise();
  }, []);

  const renderCardItem = (data) => {
    return data?.map((franchiseItem, index) => {
      const storeMap = franchiseStoreListInfoData.filter(
        (storeItem) => storeItem.id === franchiseItem.storeId,
      );

      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Franchise Mapped Store :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {storeMap[0].storeName}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Revenue Calculate On :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {franchiseItem?.revenueCalculateOn
                      ? formatDate(franchiseItem?.revenueCalculateOn)
                      : "N/A"}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1 "
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div
                    className="mr-4 mt-2 flex cursor-pointer"
                    onClick={() =>
                      navigate("/franchise-store-order-revenue", {
                        state: {
                          item: franchiseItem,
                          storeName: storeMap[0].storeName,
                        },
                      })
                    }
                  >
                    <img
                      src={"Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif"}
                      style={{
                        height: 25,
                        width: 25,
                      }}
                    />
                    <div className="ml-4">
                      <p
                        className="text-md font-normal capitalize"
                        style={{ color: "#75879B" }}
                      >
                        Revenue :
                      </p>
                      <p className="text-lg font-medium capitalize">
                        Click Here
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div
                    className="mr-4 mt-2 flex cursor-pointer"
                    onClick={() =>
                      navigate("/franchise-store-service-wise-revenue", {
                        state: {
                          item: franchiseItem,
                          storeName: storeMap[0].storeName,
                        },
                      })
                    }
                  >
                    <img
                      src={"Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif"}
                      style={{
                        height: 25,
                        width: 25,
                      }}
                    />
                    <div className="ml-4">
                      <p
                        className="text-md font-normal capitalize"
                        style={{ color: "#75879B" }}
                      >
                        Service Wise Revenue:
                      </p>
                      <p className="text-lg font-medium capitalize">
                        Click Here
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/franchise-config-list", {
                      state: {
                        franchiseItem: item,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Franchise Store
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : franchiseListInfoData?.length > 0 ? (
          <div>
            <div>{renderCardItem(franchiseListInfoData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Franchise List Found</p>
          </div>
        )}
      </div>

      {userRole === "BY_ACCOUNTANT" ? (
        <FinanceAdminMenu setVisible={setVisible} visible={visible} />
      ) : (
        <AdminMenu setVisible={setVisible} visible={visible} />
      )}
    </div>
  );
};

export default FranchiseStoreListAdmin;
